import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getAllCurrencies = () => {
    return axios.get(`/api/currency/list`, { headers: authHeaderJson() } );
};

export {
    getAllCurrencies,
}